import { FieldErrors, useFormContext } from 'react-hook-form'
import styles from './styles.module.scss'
import { AddressData, CustomerDetailsData } from '../../../config'
import { InputErrorMessage } from './InputErrorMessage'
import { Address } from '@components/account/types'

type InputControllerProps = {
  name: string
  id: keyof AddressData | keyof CustomerDetailsData
  type: string
  required?: boolean
  errors?: FieldErrors<Address>
  placeholder?: string
}

export default function InputField({
  name,
  id,
  type,
  required = false,
  placeholder
}: InputControllerProps) {
  const {
    register,
    formState: { errors }
  } = useFormContext()

  return (
    <label htmlFor={id} className={styles.InputField}>
      <span className={`${required ? styles.InputField__required : ''}`}>
        {name}
      </span>
      <input
        {...register(id)}
        id={id}
        name={id}
        type={type}
        aria-label={name}
        placeholder={placeholder}
      />
      {errors && <InputErrorMessage name={id} errors={errors} />}
    </label>
  )
}
